/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-case-declarations */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable eqeqeq */
/* eslint-disable no-debugger */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import { motion } from 'framer-motion';
import React, {
    useEffect, useState, useRef, useCallback, useContext,
} from 'react';
import { connect } from 'react-redux';
import SlidingPane from 'react-sliding-pane';
import { UserActions } from '../../redux/actions/user.action';
import { userService } from '../../service/user.service';
import TableHeader from '../../TableHeader';
import CustomToast from '../../Components/AlertPopup';
import ItemSkeleton from '../../Components/Skeletons/itemSkeleton';
import FilterModal from './FilterModal';
import Pagination from '../../Components/Pagination';
import HeaderContext from '../../Components/Context/HeaderContext';
import ListOffers from './ListOffers';
import { DistributorActions } from '../../redux/actions';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import { distributorService } from '../../service/distributor.service';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

function ManageOffers({
    getUserList, offerList, SortUser, handlePagination, AdminUserPagination,
}) {
    const [isLoaded, setisLoaded] = useState(true);
    const [isPaneOpen, setisPaneOpen] = useState(false);
    const [NoUser, setNoUser] = useState(false);
    const [showSuccess, setshowSuccess] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [title, settitle] = useState(' Otp Verification Successful!');
    const [sort, setsort] = useState(false);
    const [totalPage, setTotalPage] = useState('');
    const [EditDAte, setEditDAte] = useState([]);
    const [editpaneopen, seteditpaneopen] = useState(false);
    const [sortType, setsortType] = useState('created_at+desc');
    const [alertShow, setalertShow] = useState(false);
    const [nextPageHasData, setnextPageHasData] = useState(false);
    const [filter, setfilter] = useState(false);
    const [OpenPopup, setOpenPopup] = useState('');
    const [linksentPopup, setlinksentPopup] = useState(false);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [loading, setloading] = useState(false);
    const [statusLoader, setstatusLoader] = useState('');
    const [actvloader, setactvloader] = useState(false);
    const [showPopup, setshowPopup] = useState(false);
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [isEditId, setisEditId] = useState('');
    const [renderPage, setrenderPage] = useState(false);
    const [render, setrender] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [color, setcolor] = useState(false);
    const [threePL, setthreePL] = useState([]);
    const [territaryList, setterritaryList] = useState([]);

    const [selected, setselected] = useState({
        offer_type: [],
        industrial_pocket: [],
        status: '',
        start_date: '',
        end_date: '',
    });
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
        collapsed,
    } = useContext(HeaderContext);
    const ref = useRef();
    /**
     * it will open sidebar modal
     */
    const handleOpen = () => {
        setisPaneOpen(true);
    };
    /**
     * Fetching user list
     */

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setisLoaded(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setfilter(false);
            setfilterValue(filterUrl);
        }
    };
    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setisLoaded(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setisLoaded(true);
    }, [currentPage, sortType]);

    const handleFetch = useCallback((() => {
        getUserList(currentPage, debouncedSearch, filterValue, sortType).then((val) => {
            if (!val.error && val.data.success_status) {
                setHardRefresh(false);
                if (val.data.data.LastEvaluatedKey !== undefined) {
                    userService.offerList(val.data.data.LastEvaluatedKey.account_id, debouncedSearch, filterValue, sortType).then((resp) => {
                        if (resp?.data?.data?.Items.length > 0) {
                            setnextPageHasData(true);
                            setNoUser(false);
                            setisLoaded(false);
                            setfilter(false);
                        } else {
                            setNoUser(true);
                            setisLoaded(false);
                            setnextPageHasData(false);
                        }
                    });
                } else {
                    setfilter(false);
                    setisLoaded(false);
                    setnextPageHasData(false);
                }
            } else {
                SetErrorMessage(val.message);
                setcolorValue(true);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(false);
                }, 3000);
            }
            setisLoaded(false);
        });
    }), [currentPage, debouncedSearch, filterValue, sortType]);

    const handleExport = useCallback((() => {
        distributorService.handleOfferExport(debouncedSearch, filterValue, sortType, exportSelected).then((val) => {
            if (val.data.success_status) {
                setshowPopup(true);
                settitle(val.data.message);
                setexportClick(false);
                setexportSelected('');
                if (val.data.url) {
                    window.open(val.data.url, '_blank');
                }
                setTimeout(() => {
                    settitle('');
                    setshowPopup(false);
                }, 3000);
            }
        }).catch((e) => {
            setexportSelected(false);
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const handleActivateOrDeactivate = (status1, code1) => {
        setactvloader(true);
        distributorService.offerActiveOrDeactivateAccount(status1, code1).then((res) => {
            if (!res.error && res.data.success_status) {
                settitle(res.data.message);
                setshowPopup(true);
                setOpenPopup('');
                setactvloader(false);
                setisLoaded(true);
                setTimeout(() => {
                    setshowPopup(false);
                }, 4000);
                handleFetch();
            } else {
                setactvloader(false);
            }
        });
    };
    const handleDependency = async () => {
        const thpl = await userService.getthreepl();
        if (thpl.data.data.length > 0) {
            const arr = [];
            thpl.data.data.forEach((mng, i) => {
                arr.push({
                    id: `pl-${i}`, label: mng.CITY,
                });
            });
            setthreePL(arr);
        }
        const territry = await userService.getTerritory();
        if (territry.data.data.length > 0) {
            const arr = [];
            territry.data.data.forEach((mng, i) => {
                arr.push({
                    id: `pt-${i}`, label: mng,
                });
            });
            setterritaryList(arr);
        }
    };
    useEffect(() => {
        handleDependency();
    }, []);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    function compare(a, b) {
        if (a.first_name < b.first_name) {
            return -1;
        }
        if (b.first_name > a.first_name) {
            return 1;
        }
        return 0;
    }
    function compareStatus(a, b) {
        if (a.admin_status < b.admin_status) {
            return -1;
        }
        if (a.admin_status > b.admin_status) {
            return 1;
        }
        return 0;
    }

    function compareRoles(a, b) {
        if (a.roles < b.roles) {
            return -1;
        }
        if (a.roles > b.roles) {
            return 1;
        }
        return 0;
    }
    function comparelast(a, b) {
        if (a.last_name < b.last_name) {
            return -1;
        }
        if (a.last_name > b.last_name) {
            return 1;
        }
        return 0;
    }

    const handleSort = useCallback((type) => {
        let data;
        if (offerList.offers) {
            const userListdata = offerList.offers.Items;

            switch (type) {
            case 'last_name':
                const data2 = userListdata && userListdata.sort(comparelast);
                if (sortType === 'last_name') {
                    SortUser(data2.reverse());
                } else {
                    SortUser(data2);
                } break;
            case 'first_name':
                const data1 = userListdata && userListdata.sort(compare);
                if (sortType === 'first_name') {
                    SortUser(data1.reverse());
                } else {
                    SortUser(data);
                }
                break;
            case 'status':
                const data4 = userListdata && userListdata.sort(compareStatus);
                if (sortType === 'status') {
                    SortUser(data4.reverse());
                } else {
                    SortUser(data4);
                } break;
            case 'roles':
                const data3 = userListdata && userListdata.sort(compareRoles);
                if (sortType === 'roles') {
                    SortUser(data3.reverse());
                } else {
                    SortUser(data3);
                } break;
            default: break;
            }
        }
    }, [sortType, offerList]);
    useEffect(() => {
        handleSort();
    }, [handleSort]);
    useEffect(() => {
        if (offerList.offers && Object.keys(offerList).length > 0 && offerList.offers.Items.length === 0) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [offerList]);
    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };
    function OtpSuccessMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                {title}
            </p>
        );
    }
    const handleClickOutside = (event) => {
        if (exportClick) {
            setexportClick(false);
        }
    };

    const previlegeassigned = AccessPrevilegesFunction('deals:create');
    const viewprevilegeassigned = AccessPrevilegesFunction('deals:view');
    const updateprevilegeassigned = AccessPrevilegesFunction('deals:update');
    const activateprevilegeassigned = AccessPrevilegesFunction('deals:activate');
    const deactivateprevilegeassigned = AccessPrevilegesFunction('deals:deactivate');

    return (
        <>
            {
                showPopup && (
                    <CustomToast
                        color={color ? '#ED1C24' : undefined}
                        open
                        message={<OtpSuccessMeessage />}
                    />
                )
            }
            <TableHeader
                exportSelected={exportSelected}
                setexportClick={setexportClick}
                setisEditId={setisEditId}
                setCurrentPage={setCurrentPage}
                searchValue={searchValue}
                setsearchValue={setsearchValue}
                filter={filter}
                setfilter={setfilter}
                setexportSelected={setexportSelected}
                exportClick={exportClick}
                previlegeassigned={previlegeassigned}
            />
            <div
                className="overflow-auto dropdown-menu sticky top-0 left-0 pb-7"
                style={{ height: 'calc(100vh - 298px)' }}
                // style={{ height: offerList.offers && Object.keys(offerList).length > 0 && offerList.offers.Items.length > 0 ? '62vh' : '' }}
                onClick={() => handleClickOutside()}
            >

                {!isLoaded
                    ? (
                        <>
                            {offerList.offers && Object.keys(offerList).length > 0 && offerList.offers.Items.length > 0
                            && (
                                <table className="w-full table-auto relative">
                                    <thead
                                        className="sticky top-0 left-0 z-[2]"
                                        style={{ zIndex: OpenPopup || exportClick ? '99' : '99' }}
                                    >
                                        <tr className="bg-[#555259] h-10">
                                            <th scope="col" className="py-2.5 px-7 min-w-[124px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Code
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7  min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Offer Tag
                                                    <a href="javascript:void(0)" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'offer_value+asc' ? 180 : 0,
                                                            }}
                                                            src="/images/sort.svg"
                                                            // className={`${sortType === 'first_name' ? 'image-rotate' : ''}`}
                                                            alt="icon"
                                                            onClick={() => {
                                                                // handleSort('first_name');
                                                                if (sortType === 'offer_value+asc') {
                                                                    setsortType('offer_value+desc');
                                                                } else if (sortType === 'offer_value+desc') {
                                                                    setsortType('offer_value+asc');
                                                                } else { setsortType('offer_value+asc'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>

                                            {/* <th scope="col" className="py-2.5 px-7 min-w-[124px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Description
                                                </span>
                                            </th> */}
                                            <th scope="col" className="py-2.5 min-w-[124px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Offer Type
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 min-w-[124px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Type
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[124px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Start Date
                                                </span>
                                            </th>
                                            <th scope="col" className="pt-4 flex justify-center px-7 min-w-[124px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    End Date
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[140px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Status
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'offer_status+asc' ? 180 : 0,
                                                            }}
                                                            // className={`${sortType === 'status' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'offer_status+asc') {
                                                                    setsortType('offer_status+desc');
                                                                } else if (sortType === 'offer_status+desc') {
                                                                    setsortType('offer_status+asc');
                                                                } else { setsortType('offer_status+asc'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 rounded-tr-lg rounded-br-lg min-w-[100px] sticky top-0 right-0 bg-[#555259]" />
                                        </tr>
                                    </thead>

                                    <>
                                        {offerList.offers && Object.keys(offerList).length > 0 && offerList.offers.Items.length > 0 && (
                                            <ListOffers
                                                setisPaneOpen={setisPaneOpen}
                                                getUserList={getUserList}
                                                userList={offerList}
                                                setisLoaded={setisLoaded}
                                                currentPage={currentPage}
                                                totalPage={totalPage}
                                                setCurrentPage={setCurrentPage}
                                                setrender={setrender}
                                                setEditDAte={setEditDAte}
                                                render={render}
                                                seteditpaneopen={seteditpaneopen}
                                                EditDAte={EditDAte}
                                                handleSort={handleSort}
                                                setsort={setsort}
                                                sort={sort}
                                                setsortType={setsortType}
                                                filter={filter}
                                                OpenPopup={OpenPopup}
                                                setOpenPopup={setOpenPopup}
                                                handleActivateOrDeactivate={handleActivateOrDeactivate}
                                                actvloader={actvloader}
                                                setactvloader={setactvloader}
                                                isEditId={isEditId}
                                                setisEditId={setisEditId}
                                                collapse={collapsed}
                                                viewprevilegeassigned={viewprevilegeassigned}
                                                updateprevilegeassigned={updateprevilegeassigned}
                                                activateprevilegeassigned={activateprevilegeassigned}
                                                deactivateprevilegeassigned={deactivateprevilegeassigned}
                                            />
                                        )}

                                    </>
                                </table>
                            )}

                            {offerList.offers && offerList.offers.Items.length === 0 && (
                                <EmptyScreen
                                    text="no Offers"
                                    url="/manage-offers/create-new-offer"
                                    action="Create New"
                                    // title="Offers"
                                    search={searchValue}
                                />
                            )}
                        </>

                    ) : <ItemSkeleton />}

            </div>

            <SlidingPane
                from="right"
                isOpen={filter}
                width="30%"
                className="z-50"
                hideHeader
                onRequestClose={() => setfilter(false)}

            >
                <FilterModal
                    filter={filter}
                    setfilter={setfilter}
                    threePL={threePL}
                    territaryList={territaryList}
                    handleFiletr={handleFilter}
                    selected={selected}
                    setselected={setselected}
                />

            </SlidingPane>
            <>
                { offerList.offers && Object.keys(offerList.offers).length > 0 && offerList.offers.number_of_pages > 1 && (
                    <Pagination handlePageClick={handlePageClick} List={offerList} currentPage={currentPage} />
                )}
            </>
        </>
    );
}
const mapState = (state) => {
    const { offerList } = state;
    return { offerList };
};
const createActors = {
    getUserList: DistributorActions.offerList,
};
const connectAdminUsers = connect(mapState, createActors)(ManageOffers);

export { connectAdminUsers as ManageOffers };
